export default function () {
  let window = `relatorio.leiloes.relacaoPatio`
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Relação de Veículos para Pátio para Leilão',
    width: '600',
    height: '300',
    minHeight: '300px',
    backdrop: false,
    maximize: false,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
    }
  }, () => import('./RelacaoPatio.vue'))
    .then((wid) => {
      console.log(wid)
    }) // return wid
}
